import { useAtomValue, useStore } from "jotai";
import { Suspense, lazy, useEffect, useRef } from "react";
import { authStateAtom } from "@stringf/store/auth";
import { endSessionAtom } from "@stringf/store/session";
import { initializeLogout } from "@stringf/services/api";
import { useQueryClient } from "@tanstack/react-query";
// Lazy so the realtime stack — FlatBuffers, the chat decoder, the notification
// cache writes — stays out of the entry bundle a signed-out visitor downloads.
const SocketListener = lazy(() =>
  import("./store/socket-hook").then((m) => ({ default: m.SocketListener }))
);

function SocketWrapper() {
  const auth = useAtomValue(authStateAtom);
  const store = useStore();
  const queryClient = useQueryClient();
  const prevUserId = useRef<string | undefined>(auth.user?.id);

  // The server refused the session (api.ts): end it, and send the user to /login.
  useEffect(() => initializeLogout(() => store.set(endSessionAtom, "expired")), [store]);

  // Clear query cache when the logged-in user changes (logout or account switch)
  useEffect(() => {
    const currentId = auth.user?.id;
    if (prevUserId.current && prevUserId.current !== currentId) {
      queryClient.clear();
    }
    prevUserId.current = currentId;
  }, [auth.user?.id, queryClient]);

  return (
    <div>
      {(auth.user || auth.anoUser) && (
        <Suspense fallback={null}>
          <SocketListener />
        </Suspense>
      )}
    </div>
  );
}

export default SocketWrapper;
